var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivedChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.698,
    height: 16.569,
    viewBox: "0 0 17.698 16.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Archive",
    transform: "translate(-653.122 -448.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-outline",
    transform: "translate(653.872 449.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M80,152v9.968a1.562,1.562,0,0,0,1.557,1.557H92.148a1.562,1.562,0,0,0,1.557-1.557V152",
    transform: "translate(-78.754 -148.457)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 16.198,
    height: 3.29,
    rx: 1.645,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M196.984,227.115l-2.492,2.492L192,227.115m2.492,1.631V224",
    transform: "translate(-186.393 -217.653)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedChatIcon);
export default __webpack_public_path__ + "static/media/archived-chat-icon.2b7b65273b1229e2e7a4f0da4d08a83e.svg";
export { ForwardRef as ReactComponent };